/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { ADGMPanel, ADGMItemDetails } from 'aurora-components';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import messages from 'aurora-translations';
import { FormattedMessage } from 'react-intl';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { isEmpty } from 'lodash';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

const EntityDetailsV2 = ({ data, classes, ...props }) => {
  const [entityCollapse, setEntityCollapse] = useState(true);

  return (
    <ADGMPanel {...props}>
      <div className={classes.entityContainer}>
        {data.length > 0 &&
          data?.map((entityDetails, index, entityArr) => {
            return (
              <div
                key={index}
                className={classNames(
                  classes.entity,
                  entityCollapse && index > 1 ? classes.noDisplay : classes.gridDisplay,
                  entityArr.length <= 2 && index === entityArr.length - 1 ? classes.noBorder : '',
                )}
              >
                <div className={classes.flexCls}>
                  <Avatar alt='avatar' className={classes.profileCls} src={entityDetails?.profilePic} />
                  <div>
                    <Typography variant='subtitle1' className={classes.labelKey}>
                      {keyEmptyCheck(entityDetails?.title)} {` #${index + 1}`}
                    </Typography>
                    <Typography variant='subtitle1' className={classes.nameCls}>
                      {keyEmptyCheck(entityDetails?.nameEn)}
                    </Typography>
                    <Typography variant='subtitle1' className={classNames(classes.nameCls, classes.ArFont)}>
                      {keyEmptyCheck(entityDetails?.nameAr)}
                    </Typography>
                  </div>
                </div>
                <Hidden smUp>
                  <Divider className={classes.divider} />
                </Hidden>
                <div className={classes.labelsWrapper}>
                  {Object.keys(entityDetails?.labels)?.map((key, entityIndex, arr) => (
                    <>
                      <div className={classes.labels}>
                        <ADGMItemDetails
                          label={keyEmptyCheck(key)}
                          value={entityDetails?.labels[key]}
                          labelClass={classes.labelKey}
                          valueClass={classes.labelValue}
                        />
                      </div>

                      <Hidden smUp>{entityIndex !== arr.length - 1 && <Divider className={classes.divider} />}</Hidden>
                    </>
                  ))}
                </div>
                {!isEmpty(entityDetails?.subItem) && (
                  <div className={classes.subItemContainer}>
                    <Typography className={classes.subItemTitle} variant='subtitle1'>
                      {entityDetails?.subItem?.title}
                    </Typography>
                    <div className={classes.labelsWrapper}>
                      {Object.keys(entityDetails?.subItem?.labels)?.map(key => (
                        <div key={key} className={classes.labels}>
                          <ADGMItemDetails
                            label={keyEmptyCheck(key)}
                            value={entityDetails?.subItem?.labels[key]}
                            labelClass={classes.labelKey}
                            valueClass={classes.labelValue}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        {!isEmpty(data) && entityCollapse && data.length > 2 ? (
          <div className={classes.viewmoreWrapper}>
            <Link onClick={() => setEntityCollapse(!entityCollapse)}>
              <FormattedMessage {...messages.view_more_service_charges} values={{ s: `${data.length - 2}` }} />
              <ExpandMoreIcon />
            </Link>
          </div>
        ) : (
          ''
        )}
        {!isEmpty(data) && !entityCollapse && (
          <div className={classes.viewmoreWrapper}>
            <Link onClick={() => setEntityCollapse(!entityCollapse)}>
              <FormattedMessage {...messages.show_less} /> <ExpandLessIcon />
            </Link>
          </div>
        )}
      </div>
    </ADGMPanel>
  );
};
EntityDetailsV2.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};
export default withStyles(styles)(EntityDetailsV2);
